import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthenticationSettings = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    email: user?.email || '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validaciones
    if (formData.newPassword && formData.newPassword !== formData.confirmPassword) {
      alert('New password and confirm password do not match');
      return;
    }

    console.log('Update authentication:', formData);
    // TODO: Save to backend
    alert('Authentication settings updated successfully!');
  };

  const handleDeactivate = () => {
    console.log('Deactivate account');
    // TODO: Call backend to deactivate
    alert('Account deactivated');
    setShowDeactivateModal(false);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="bg-gray-900 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button
            onClick={() => navigate('/app')}
            className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Volver al Dashboard</span>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold mb-12">Authentication</h1>

        <form onSubmit={handleSubmit} className="space-y-12">
          {/* Email & Password Section */}
          <div>
            <h2 className="text-xl font-semibold mb-6">Email & password</h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              {/* Email */}
              <div>
                <label className="block text-sm mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled
                  className="w-full px-4 py-3 bg-gray-800 border border-white/10 rounded-lg text-gray-400 cursor-not-allowed"
                />
              </div>

              {/* Current Password */}
              <div>
                <label className="block text-sm mb-2">Current password</label>
                <input
                  type="password"
                  name="currentPassword"
                  value={formData.currentPassword}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-white/10 rounded-lg focus:outline-none focus:border-teal-500 transition-colors"
                />
              </div>

              {/* New Password */}
              <div>
                <label className="block text-sm mb-2">New password</label>
                <input
                  type="password"
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-white/10 rounded-lg focus:outline-none focus:border-teal-500 transition-colors"
                />
              </div>

              {/* Confirm Password */}
              <div>
                <label className="block text-sm mb-2">Confirm password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-white/10 rounded-lg focus:outline-none focus:border-teal-500 transition-colors"
                />
              </div>
            </div>

            {/* Save Button */}
            <div className="mt-8">
              <button
                type="submit"
                className="px-8 py-3 bg-white text-black font-semibold rounded-full hover:bg-gray-200 transition-colors"
              >
                Save changes
              </button>
            </div>
          </div>

          {/* Deactivate Account Section */}
          <div className="pt-8 border-t border-white/10">
            <h2 className="text-xl font-semibold mb-4">Deactivate account</h2>
            <p className="text-gray-400 text-sm mb-6 max-w-3xl">
              Careful! This will permanently deactivate your account in the current community. You will no longer 
              have access to this community after you do this. Your Circle account will remain active, ensuring 
              access to other subscribed communities.
            </p>
            <button
              type="button"
              onClick={() => setShowDeactivateModal(true)}
              className="px-8 py-3 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 transition-colors"
            >
              Deactivate my account
            </button>
          </div>
        </form>
      </main>

      {/* Deactivate Confirmation Modal */}
      {showDeactivateModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
          <div className="bg-gray-900 border border-white/10 rounded-2xl p-8 max-w-md w-full">
            <h3 className="text-2xl font-bold mb-4">Deactivate Account</h3>
            <p className="text-gray-400 mb-6">
              Are you sure you want to deactivate your account? This action cannot be undone.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={() => setShowDeactivateModal(false)}
                className="flex-1 px-6 py-3 border border-white/20 rounded-full hover:bg-white/5 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDeactivate}
                className="flex-1 px-6 py-3 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 transition-colors"
              >
                Deactivate
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthenticationSettings;
